import { call, put, select } from 'redux-saga/effects';
import { SLOTS } from 'types';
import { betMessages } from 'constants/toastMessages';
import { availableBetsSelector } from 'core/widgets/Bet/BetAvailability';
import { updateBetsSaga } from 'core/widgets/Bet/sagas/createPendingBetSaga';
import { getBetSum } from 'core/widgets/Bet/utils';
import { addToastAction } from 'core/widgets/Toast/actions';
import { balanceSelector } from 'core/widgets/User';
import { ToastTypes } from 'types/toast';
import { repeatBetSuccessAction } from '../actions';
import { betRepeatRootSelector } from '../selectors';
import { IBetRepeatState } from '../types';

export function* repeatBetSaga() {
  const balance: number | null = yield select(balanceSelector);
  const { isUsed, value }: IBetRepeatState = yield select(betRepeatRootSelector);
  const availableBets: SLOTS[] = yield select(availableBetsSelector);

  if (value === null || balance === null || isUsed) {
    return;
  }

  if (availableBets.length > 0) {
    const hasUnavailableBet = Object.entries(value).some(
      ([slot, betValue]) => betValue > 0 && !availableBets.includes(slot as SLOTS),
    );

    if (hasUnavailableBet) {
      yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.BET_NOT_AVAILABLE }));
      return;
    }
  }

  const lastBetSum = getBetSum(value);

  if (lastBetSum > balance) {
    yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.LOW_BALANCE }));
    return;
  }

  yield put(repeatBetSuccessAction());
  yield call(updateBetsSaga, {
    present: value,
    past: [],
  });
}
